// Values the Usage API takes and returns, with their language constants.

export const USAGE_AREAS = [
    { value: 'film_tv', text: 'lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_FILMTV' }
]

export const DATA_TYPES = [
    { value: 'broadcast_schedule', text: 'lang_PUBLISHING_USAGE_CAPTION_BROADCAST_SCHEDULE' },
    { value: 'usage_statement', text: 'lang_PUBLISHING_USAGE_CAPTION_USAGE_STATEMENT' }
]

// The managed source list holds GEMA so far (backend: alv_publishing_usage_sources)
export const SOURCES = [
    { value: 'GEMA', text: 'GEMA' }
]

// The mapping domain each data type imports through
export const IMPORT_DOMAINS = {
    broadcast_schedule: 'publishing_broadcast_events',
    usage_statement: 'publishing_usage_records'
}

export const IMPORT_STATUSES = {
    importing: 'lang_PUBLISHING_USAGE_CAPTION_STATUS_IMPORTING',
    imported: 'lang_PUBLISHING_USAGE_CAPTION_STATUS_IMPORTED',
    failed: 'lang_GENERIC_CAPTION_STATUS_FAILED',
    deleting: 'lang_PUBLISHING_USAGE_CAPTION_STATUS_DELETING',
    not_imported: 'lang_LABEL_RELEASES_IMPORT_REPORT_NOT_IMPORTED'
}

export const OUTCOMES = [
    { value: 'complaint', text: 'lang_PUBLISHING_USAGE_CAPTION_OUTCOME_COMPLAINT', color: 'error' },
    { value: 'needs_review', text: 'lang_PUBLISHING_USAGE_CAPTION_OUTCOME_NEEDS_REVIEW', color: 'warning' },
    { value: 'needs_sheet', text: 'lang_PUBLISHING_USAGE_CAPTION_OUTCOME_NEEDS_SHEET', color: 'standardBrownIcon' },
    { value: 'reported', text: 'lang_PUBLISHING_USAGE_CAPTION_OUTCOME_REPORTED', color: 'buttonNewEntity' },
    { value: 'out_of_scope', text: 'lang_PUBLISHING_USAGE_CAPTION_OUTCOME_OUT_OF_SCOPE', color: 'iconDelete' }
]

export const REASONS = [
    'airing_unreported', 'work_missing_from_report', 'duration_short', 'airing_ambiguous', 'work_has_no_gema_number',
    'no_sheet', 'sheet_has_no_works', 'several_sheets', 'station_unknown', 'station_out_of_scope',
    'night_airing_rule_pending', 'start_time_missing', 'airing_reported', 'work_reported',
    'works_from_statement', 'airing_unreported_no_works'
].map(value => ({ value, text: 'lang_PUBLISHING_USAGE_CAPTION_REASON_' + value.toUpperCase() }))

export const DECISIONS = [
    { value: 'undecided', text: 'lang_PUBLISHING_USAGE_CAPTION_DECISION_UNDECIDED' },
    { value: 'accepted', text: 'lang_GENERIC_CAPTION_STATUS_ACCEPTED' },
    { value: 'rejected', text: 'lang_GENERIC_CAPTION_STATUS_DECLINED' }
]

// How an episode pattern's numbers count (backend: NumberingScheme)
export const NUMBERINGS = [
    { value: 'absolute', text: 'lang_PUBLISHING_USAGE_CAPTION_SETTINGS_NUMBERING_ABSOLUTE' },
    { value: 'in_season', text: 'lang_PUBLISHING_USAGE_CAPTION_SETTINGS_NUMBERING_IN_SEASON' }
]

export const VERDICTS = {
    exact: 'lang_PUBLISHING_USAGE_CAPTION_VERDICT_EXACT',
    probable: 'lang_PUBLISHING_USAGE_CAPTION_VERDICT_PROBABLE',
    ambiguous: 'lang_PUBLISHING_USAGE_CAPTION_VERDICT_AMBIGUOUS',
    unreported: 'lang_PUBLISHING_USAGE_CAPTION_VERDICT_UNREPORTED',
    not_compared: 'lang_PUBLISHING_USAGE_CAPTION_VERDICT_NOT_COMPARED'
}

// GEMA's form vocabularies for the complaint export: external values, sent as they are
// (backend: GemaComplaintVocabulary; the preview answers the defaults in options)
export const MUSIC_USES = ['Illustrationsmusik', 'Vor- oder Abspannmusik', 'Titelmusik', 'Trailer', 'Visualisierte Musik']
export const SOUNDFILE_SOURCES = ['GEMA', 'Sender', 'BMAT', 'Andere/Other']

/** Years and quarters for the period filter and the import, newest first, as the API writes them. */
export function periodOptions(fromYear = 2015) {
    const options = []
    for (let year = new Date().getFullYear() + 1; year >= fromYear; year--) {
        options.push({ value: String(year), text: String(year) })
        for (let quarter = 4; quarter >= 1; quarter--) {
            options.push({ value: year + '-Q' + quarter, text: year + '-' + quarter + ' (Q' + quarter + ')' })
        }
    }
    return options
}

export function optionText(options, value) {
    const option = options.find(o => o.value === value)
    return option ? option.text : value
}
